import React from "react";
import styled from "styled-components";

import brk from "../../util/breakpoints";

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  @media ${brk.device.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Marker = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--lime);
  font-family: var(--fontMono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const Signal = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--lime);
  box-shadow: 0 0 28px 6px rgba(184, 242, 61, 0.19);
`;

const Title = styled.h2`
  color: var(--text);
  font-family: var(--fontHeading);
  font-size: clamp(32px, 5vw, 44px);
  font-weight: 700;
  line-height: 1.08;
`;

function SectionHeading(props) {
  return (
    <Wrapper>
      <Copy>
        <Marker>
          <Signal />
          {props.label}
        </Marker>
        <Title>{props.title}</Title>
      </Copy>
      {props.children}
    </Wrapper>
  );
}

export default SectionHeading;
